export default class Accounts {
    constructor(headers) {
        this.headers = headers
    }
    async get(uuid = "me") {
        try {
            const request = await fetch("/api/v1/accounts/" + uuid, { headers: this.headers });
            if (request.status !== 200) throw new Error();
            const account = await request.json();
            if (uuid === "me") {
                return !account.default;
            }
            else {
                return account
            }
        }
        catch (e) {
            return false;
        }

    }
    async default() {
        try {
            const request = await fetch("/api/v1/accounts/me");
            if (request.status !== 200) throw new Error();
            const account = await request.json();
            return account
        }
        catch (e) {
            return false;
        }

    }
}